<template>
    <span>
        <router-link v-if="item.device_link && $canDo('machineDetailPage')" :to="item.device_link">
            <template v-if="isClerkDevice && item.x_data && item.x_data.clerk_name">
                {{item.device_info || item.device_id }} / ({{item.x_data.clerk_name}})
            </template>

            <template v-else>
                {{item.device_info || item.device_id }}
            </template>
        </router-link>
        <template v-else>
            {{item.device_info || item.short_id || item.device_id }}
        </template>
    </span>
</template>

<script>

export default {
  name: 'device-link',
  props: {
    item: { required: true },
    isClerkDevice: { type: Boolean, required: false, default: false}
  }
}

</script>



// WEBPACK FOOTER //
// src/globals/deviceLink.vue